import { render, staticRenderFns } from "./LoginCallback.vue?vue&type=template&id=0de36d7a"
import script from "./LoginCallback.vue?vue&type=script&lang=js"
export * from "./LoginCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports